import { render } from "./icon-book.vue?vue&type=template&id=f10714b8"
import script from "./icon-book.vue?vue&type=script&lang=js"
export * from "./icon-book.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__